import {InputHTMLAttributes, PureComponent, Ref} from 'react';
import {join} from '../../utils';
import {Selectors} from '../controls.selectors';

import styles from './radio.module.less';

type BaseRadioAttributes = Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'checked' | 'type'>

export type RadioProps = {
	value: string | number;
	checked: boolean;
	innerRef?: Ref<HTMLLabelElement>;
	'data-cy'?: string
} & BaseRadioAttributes;

export class Radio extends PureComponent<RadioProps> {
	private id = 'radio-' + Math.round(Math.random() * 10000);

	public override render() {
		const {id, className, children, innerRef, tabIndex, ...inputProps} = this.props;
		const inputID = id || this.id;
		return <div>
			<input {...inputProps}
			       data-cy={undefined}
			       type='radio'
			       className={styles.radioInput}
			       id={inputID}
			       tabIndex={-1}/>
			<label htmlFor={inputID}
			       aria-checked={inputProps.checked}
			       role='radio'
			       data-cy={inputProps['data-cy'] || Selectors.Radio}
			       ref={innerRef}
			       aria-disabled={this.props.disabled}
			       className={join(this.props.checked && styles.checked, this.props.disabled && styles.disabled, styles.label, className)}>
				<div className={join(styles.radio, styles.circleOut)} tabIndex={tabIndex || 0}>
					<div className={join(styles.circleInner)}/>
				</div>
				{children}
			</label>
		</div>;
	}
}

export default Radio;
